/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Home, Eye, EyeOff, RefreshCw, LogOut, Edit2, Save, X, Upload, Download, Volume2, Sparkles, Hash, Trophy, FileDown, FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { API, BACKEND_URL, resolveUrl, useAdmin } from "../adminShared";
import { PlacementEditor } from "../PlacementEditor";
import { VotingColumnEditor } from "../VotingColumnEditor";

export const TypographySection = () => {
  const {
    countries, setCountries, votes, setVotes, events, setEvents,
    activeEvent, setActiveEvent, showCreateEvent, setShowCreateEvent, newEventName, setNewEventName,
    copyFromEventId, setCopyFromEventId, creatingEvent, setCreatingEvent, showRenameEvent, setShowRenameEvent,
    renameEventName, setRenameEventName, importFile, setImportFile, showImportConfirm, setShowImportConfirm,
    importing, setImporting, newCountry, setNewCountry, editingCountry, setEditingCountry,
    backgroundVideo, setBackgroundVideo, bgVideoBlur, setBgVideoBlur, bgVideoBrightness, setBgVideoBrightness, bgVideoOpacity, setBgVideoOpacity, fontTitle, setFontTitle, fontSubtitle, setFontSubtitle,
    fontCountry, setFontCountry, fontPoints, setFontPoints, fontVoting, setFontVoting,
    customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName, customFontSubtitleUrl, setCustomFontSubtitleUrl,
    customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl, customFontCountryName, setCustomFontCountryName,
    customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName, customFontVotingUrl, setCustomFontVotingUrl,
    customFontVotingName, setCustomFontVotingName, fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle,
    fontSizeCountry, setFontSizeCountry, fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    rowBgEven, setRowBgEven, rowBgOdd, setRowBgOdd, rowBgEvenTranslucent, setRowBgEvenTranslucent, rowBgOddTranslucent, setRowBgOddTranslucent, rowBadgeTranslucent, setRowBadgeTranslucent, logoUrl, setLogoUrl,
    logoPosition, setLogoPosition, logoSize, setLogoSize, logoZIndex, setLogoZIndex,
    logoOpacity, setLogoOpacity, extraImage1Url, setExtraImage1Url, extraImage1Position, setExtraImage1Position,
    extraImage1Size, setExtraImage1Size, extraImage1ZIndex, setExtraImage1ZIndex, extraImage1Opacity, setExtraImage1Opacity,
    extraImage2Url, setExtraImage2Url, extraImage2Position, setExtraImage2Position, extraImage2Size, setExtraImage2Size,
    extraImage2ZIndex, setExtraImage2ZIndex, extraImage2Opacity, setExtraImage2Opacity, extraImage3Url, setExtraImage3Url,
    extraImage3Position, setExtraImage3Position, extraImage3Size, setExtraImage3Size, extraImage3ZIndex, setExtraImage3ZIndex,
    extraImage3Opacity, setExtraImage3Opacity, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, positionBadgeTranslucent, setPositionBadgeTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, mystery12Text, setMystery12Text, mysteryHiddenPoints, setMysteryHiddenPoints, voteDisplayColumns, setVoteDisplayColumns,
    showVoterBorder, setShowVoterBorder, showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary,
    fontTitleItalic, setFontTitleItalic, fontSubtitleItalic, setFontSubtitleItalic, fontCountryItalic, setFontCountryItalic,
    fontPointsItalic, setFontPointsItalic, fontVotingItalic, setFontVotingItalic, fontVotingSecondaryItalic, setFontVotingSecondaryItalic,
    customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl, customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled,
    overlay12DurationMode, setOverlay12DurationMode, overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle,
    overlay12BgColor, setOverlay12BgColor, overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives,
    overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12ShowConfetti, setOverlay12ShowConfetti, overlay12Visible, setOverlay12Visible, previewGiverId, setPreviewGiverId,
    previewRecipientId, setPreviewRecipientId, winnerOverlayEnabled, setWinnerOverlayEnabled, winnerOverlayDurationMode, setWinnerOverlayDurationMode,
    winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle, winnerOverlayBgColor, setWinnerOverlayBgColor,
    winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText, winnerOverlaySubtitleText, setWinnerOverlaySubtitleText,
    winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti, winnerOverlayShowPoints, setWinnerOverlayShowPoints,
    winnerOverlayVisible, setWinnerOverlayVisible, overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle,
    overlay12FontCountry, setOverlay12FontCountry, overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale,
    winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle, winnerOverlayFontCountry, setWinnerOverlayFontCountry,
    winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale, loading, setLoading,
    exportingPdf, setExportingPdf, winnerPreviewId, setWinnerPreviewId, adminInitRef, adminPollRef,
    navigate, fetchCurrentVoterStatus, handleHideOverlay12, handlePreviewOverlay12, handleShowWinner, handleHideWinner,
    getFontFormat, fetchBackground, handleSetBackground, handleExportPdf, handleFileUpload, fetchCountries,
    fetchVotes, downloadFromApi, handleExportVotesPdf, handleExportVotesExcel, fetchEvents, reloadEventData,
    handleSelectEvent, handleCreateEvent, handleRenameEvent, handleExportEvent, handleImportEvent, handleAddCountry,
    handleDeleteCountry, handleSetCurrentVoter, handleResetVotes, handleLogout, handleApplyVotes, handleReveal12Points,
    handleEditCountry, handleUpdateCountry, handleToggleBadge, handleToggleTranslucent, votingCountries, juryMembers,
    votedCountries,
  } = useAdmin();
  // Convert a hex/rgba color string into a #rrggbb value usable by <input type="color">.
  const toPickerHex = (c) => {
    if (!c || typeof c !== 'string') return "#000000";
    if (c.startsWith('#')) return c.slice(0, 7).padEnd(7, '0');
    const m = c.match(/rgba?\(([^)]+)\)/i);
    if (m) {
      const parts = m[1].split(',').map((s) => parseInt(s.trim(), 10));
      const h = (n) => Math.max(0, Math.min(255, isNaN(n) ? 0 : n)).toString(16).padStart(2, '0');
      return `#${h(parts[0])}${h(parts[1])}${h(parts[2])}`;
    }
    return "#000000";
  };
  return (
    <>
                {/* Tipografía por Secciones */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700">
                  <Label className="text-zinc-300 mb-3 block font-semibold text-lg">Tipografía por Secciones</Label>
                  <p className="text-zinc-500 text-sm mb-4">Configura fuentes diferentes para cada parte del visualizador</p>
                  
                  <div className="grid md:grid-cols-2 gap-4">
                    {/* Fuente Título */}
                    <div>
                      <Label htmlFor="font-title" className="text-zinc-300 mb-2 block">Título Principal</Label>
                      <select
                        id="font-title"
                        data-testid="select-font-title"
                        value={fontTitle}
                        onChange={(e) => setFontTitle(e.target.value)}
                        className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                      >
                        <option value="Unbounded">Unbounded</option>
                        <option value="Inter">Inter</option>
                        <option value="Roboto">Roboto</option>
                        <option value="Poppins">Poppins</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Oswald">Oswald</option>
                        <option value="Custom">Personalizada</option>
                      </select>
                      {fontTitle === "Custom" && (
                        <div className="mt-2 flex gap-2 items-center">
                          <input
                            type="file"
                            id="font-title-file"
                            accept=".ttf,.otf,.woff,.woff2"
                            className="hidden"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const url = await handleFileUpload(file, 'temp');
                                if (url) {
                                  setCustomFontTitleUrl(url);
                                  setCustomFontTitleName(file.name.replace(/\.[^/.]+$/, ""));
                                }
                              }
                            }}
                          />
                          <Button
                            type="button"
                            onClick={() => document.getElementById('font-title-file').click()}
                            variant="outline"
                            size="sm"
                            className="bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                          >
                            <Upload className="w-3 h-3 mr-1" />
                            Subir
                          </Button>
                          {customFontTitleName && <span className="text-green-400 text-xs">✓ {customFontTitleName}</span>}
                        </div>
                      )}
                      <label className="flex items-center gap-2 mt-2 cursor-pointer select-none w-fit">
                        <input type="checkbox" checked={fontTitleItalic} onChange={(e) => setFontTitleItalic(e.target.checked)} data-testid="checkbox-font-title-italic" className="accent-pink-500 w-4 h-4" />
                        <span className="text-zinc-400 text-xs italic">Cursiva</span>
                      </label>
                      <p className="text-zinc-600 text-xs mt-1">&quot;CLASIFICACIÓN EN VIVO&quot;</p>
                    </div>

                    {/* Fuente Subtítulo */}
                    <div>
                      <Label htmlFor="font-subtitle" className="text-zinc-300 mb-2 block">Subtítulo</Label>
                      <select
                        id="font-subtitle"
                        data-testid="select-font-subtitle"
                        value={fontSubtitle}
                        onChange={(e) => setFontSubtitle(e.target.value)}
                        className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                      >
                        <option value="Unbounded">Unbounded</option>
                        <option value="Inter">Inter</option>
                        <option value="Roboto">Roboto</option>
                        <option value="Poppins">Poppins</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Oswald">Oswald</option>
                        <option value="Custom">Personalizada</option>
                      </select>
                      {fontSubtitle === "Custom" && (
                        <div className="mt-2 flex gap-2 items-center">
                          <input
                            type="file"
                            id="font-subtitle-file"
                            accept=".ttf,.otf,.woff,.woff2"
                            className="hidden"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const url = await handleFileUpload(file, 'temp');
                                if (url) {
                                  setCustomFontSubtitleUrl(url);
                                  setCustomFontSubtitleName(file.name.replace(/\.[^/.]+$/, ""));
                                }
                              }
                            }}
                          />
                          <Button
                            type="button"
                            onClick={() => document.getElementById('font-subtitle-file').click()}
                            variant="outline"
                            size="sm"
                            className="bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                          >
                            <Upload className="w-3 h-3 mr-1" />
                            Subir
                          </Button>
                          {customFontSubtitleName && <span className="text-green-400 text-xs">✓ {customFontSubtitleName}</span>}
                        </div>
                      )}
                      <label className="flex items-center gap-2 mt-2 cursor-pointer select-none w-fit">
                        <input type="checkbox" checked={fontSubtitleItalic} onChange={(e) => setFontSubtitleItalic(e.target.checked)} data-testid="checkbox-font-subtitle-italic" className="accent-pink-500 w-4 h-4" />
                        <span className="text-zinc-400 text-xs italic">Cursiva</span>
                      </label>
                      <p className="text-zinc-600 text-xs mt-1">&quot;Sistema de Votación Eurovisión&quot;</p>
                    </div>

                    {/* Fuente Países */}
                    <div>
                      <Label htmlFor="font-country" className="text-zinc-300 mb-2 block">Nombres de Países</Label>
                      <select
                        id="font-country"
                        data-testid="select-font-country"
                        value={fontCountry}
                        onChange={(e) => setFontCountry(e.target.value)}
                        className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                      >
                        <option value="Unbounded">Unbounded</option>
                        <option value="Inter">Inter</option>
                        <option value="Roboto">Roboto</option>
                        <option value="Poppins">Poppins</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Oswald">Oswald</option>
                        <option value="Custom">Personalizada</option>
                      </select>
                      {fontCountry === "Custom" && (
                        <div className="mt-2 flex gap-2 items-center">
                          <input
                            type="file"
                            id="font-country-file"
                            accept=".ttf,.otf,.woff,.woff2"
                            className="hidden"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const url = await handleFileUpload(file, 'temp');
                                if (url) {
                                  setCustomFontCountryUrl(url);
                                  setCustomFontCountryName(file.name.replace(/\.[^/.]+$/, ""));
                                }
                              }
                            }}
                          />
                          <Button
                            type="button"
                            onClick={() => document.getElementById('font-country-file').click()}
                            variant="outline"
                            size="sm"
                            className="bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                          >
                            <Upload className="w-3 h-3 mr-1" />
                            Subir
                          </Button>
                          {customFontCountryName && <span className="text-green-400 text-xs">✓ {customFontCountryName}</span>}
                        </div>
                      )}
                      <label className="flex items-center gap-2 mt-2 cursor-pointer select-none w-fit">
                        <input type="checkbox" checked={fontCountryItalic} onChange={(e) => setFontCountryItalic(e.target.checked)} data-testid="checkbox-font-country-italic" className="accent-pink-500 w-4 h-4" />
                        <span className="text-zinc-400 text-xs italic">Cursiva</span>
                      </label>
                      <p className="text-zinc-600 text-xs mt-1">España, Italia, Francia...</p>
                    </div>

                    {/* Fuente Puntos */}
                    <div>
                      <Label htmlFor="font-points" className="text-zinc-300 mb-2 block">Puntos/Números</Label>
                      <select
                        id="font-points"
                        data-testid="select-font-points"
                        value={fontPoints}
                        onChange={(e) => setFontPoints(e.target.value)}
                        className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                      >
                        <option value="Unbounded">Unbounded</option>
                        <option value="Inter">Inter</option>
                        <option value="Roboto">Roboto</option>
                        <option value="Poppins">Poppins</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Oswald">Oswald</option>
                        <option value="Chivo Mono">Chivo Mono (Monoespaciada)</option>
                        <option value="Custom">Personalizada</option>
                      </select>
                      {fontPoints === "Custom" && (
                        <div className="mt-2 flex gap-2 items-center">
                          <input
                            type="file"
                            id="font-points-file"
                            accept=".ttf,.otf,.woff,.woff2"
                            className="hidden"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const url = await handleFileUpload(file, 'temp');
                                if (url) {
                                  setCustomFontPointsUrl(url);
                                  setCustomFontPointsName(file.name.replace(/\.[^/.]+$/, ""));
                                }
                              }
                            }}
                          />
                          <Button
                            type="button"
                            onClick={() => document.getElementById('font-points-file').click()}
                            variant="outline"
                            size="sm"
                            className="bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                          >
                            <Upload className="w-3 h-3 mr-1" />
                            Subir
                          </Button>
                          {customFontPointsName && <span className="text-green-400 text-xs">✓ {customFontPointsName}</span>}
                        </div>
                      )}
                      <label className="flex items-center gap-2 mt-2 cursor-pointer select-none w-fit">
                        <input type="checkbox" checked={fontPointsItalic} onChange={(e) => setFontPointsItalic(e.target.checked)} data-testid="checkbox-font-points-italic" className="accent-pink-500 w-4 h-4" />
                        <span className="text-zinc-400 text-xs italic">Cursiva</span>
                      </label>
                      <p className="text-zinc-600 text-xs mt-1">12, 10, 8, 7...</p>
                    </div>

                    {/* Fuente Votación */}
                    <div>
                      <Label htmlFor="font-voting" className="text-zinc-300 mb-2 block">Columna Votación</Label>
                      <select
                        id="font-voting"
                        data-testid="select-font-voting"
                        value={fontVoting}
                        onChange={(e) => setFontVoting(e.target.value)}
                        className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                      >
                        <option value="Unbounded">Unbounded</option>
                        <option value="Inter">Inter</option>
                        <option value="Roboto">Roboto</option>
                        <option value="Poppins">Poppins</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Oswald">Oswald</option>
                        <option value="Custom">Personalizada</option>
                      </select>
                      {fontVoting === "Custom" && (
                        <div className="mt-2 flex gap-2 items-center">
                          <input
                            type="file"
                            id="font-voting-file"
                            accept=".ttf,.otf,.woff,.woff2"
                            className="hidden"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const url = await handleFileUpload(file, 'temp');
                                if (url) {
                                  setCustomFontVotingUrl(url);
                                  setCustomFontVotingName(file.name.replace(/\.[^/.]+$/, ""));
                                }
                              }
                            }}
                          />
                          <Button
                            type="button"
                            onClick={() => document.getElementById('font-voting-file').click()}
                            variant="outline"
                            size="sm"
                            className="bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                          >
                            <Upload className="w-3 h-3 mr-1" />
                            Subir
                          </Button>
                          {customFontVotingName && <span className="text-green-400 text-xs">✓ {customFontVotingName}</span>}
                        </div>
                      )}
                      <label className="flex items-center gap-2 mt-2 cursor-pointer select-none w-fit">
                        <input type="checkbox" checked={fontVotingItalic} onChange={(e) => setFontVotingItalic(e.target.checked)} data-testid="checkbox-font-voting-italic" className="accent-pink-500 w-4 h-4" />
                        <span className="text-zinc-400 text-xs italic">Cursiva</span>
                      </label>
                      <p className="text-zinc-600 text-xs mt-1">&quot;VOTANDO AHORA&quot;</p>
                    </div>

                    {/* Fuente Votación Secundaria */}
                    <div>
                      <Label htmlFor="font-voting-secondary" className="text-zinc-300 mb-2 block">Votación (Secundaria)</Label>
                      <select
                        id="font-voting-secondary"
                        data-testid="select-font-voting-secondary"
                        value={fontVotingSecondary}
                        onChange={(e) => setFontVotingSecondary(e.target.value)}
                        className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-pink-500"
                      >
                        <option value="Unbounded">Unbounded</option>
                        <option value="Inter">Inter</option>
                        <option value="Roboto">Roboto</option>
                        <option value="Poppins">Poppins</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Oswald">Oswald</option>
                        <option value="Custom">Personalizada</option>
                      </select>
                      {fontVotingSecondary === "Custom" && (
                        <div className="mt-2 flex gap-2 items-center">
                          <input
                            type="file"
                            id="font-voting-secondary-file"
                            accept=".ttf,.otf,.woff,.woff2"
                            className="hidden"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const url = await handleFileUpload(file, 'temp');
                                if (url) {
                                  setCustomFontVotingSecondaryUrl(url);
                                  setCustomFontVotingSecondaryName(file.name.replace(/\.[^/.]+$/, ""));
                                }
                              }
                            }}
                          />
                          <Button
                            type="button"
                            onClick={() => document.getElementById('font-voting-secondary-file').click()}
                            variant="outline"
                            size="sm"
                            className="bg-zinc-800 border-zinc-700 text-white hover:bg-zinc-700"
                          >
                            <Upload className="w-3 h-3 mr-1" />
                            Subir
                          </Button>
                          {customFontVotingSecondaryName && <span className="text-green-400 text-xs">&#10003; {customFontVotingSecondaryName}</span>}
                        </div>
                      )}
                      <label className="flex items-center gap-2 mt-2 cursor-pointer select-none w-fit">
                        <input type="checkbox" checked={fontVotingSecondaryItalic} onChange={(e) => setFontVotingSecondaryItalic(e.target.checked)} data-testid="checkbox-font-voting-secondary-italic" className="accent-pink-500 w-4 h-4" />
                        <span className="text-zinc-400 text-xs italic">Cursiva</span>
                      </label>
                      <p className="text-zinc-600 text-xs mt-1">Textos secundarios de votación</p>
                    </div>
                  </div>
                  
                  {/* Info sobre fuentes personalizadas */}
                  <div className="mt-4 p-3 bg-zinc-900/50 rounded-lg border border-zinc-700">
                    <p className="text-zinc-400 text-xs">
                      Selecciona &quot;Personalizada&quot; en cualquier sección y sube tu fuente usando el botón &quot;Subir&quot; que aparecerá.
                      Formatos soportados: TTF, OTF, WOFF, WOFF2.
                    </p>
                  </div>
                </div>
    </>
  );
};
